/* @ngInject */
export default function NvCompletedCourseCard(
  CurrentUserManager,
  InteroperabilityRoutes,
  InstitutionsManager,
) {
  return {
    scope: {
      completedCourse: '=',
      roleInfo: '=?',
    },
    controller: function ctrl($scope) {
'ngInject';
      const vm = this;

      vm.CurrentUserManager = CurrentUserManager;
      vm.InteroperabilityRoutes = InteroperabilityRoutes;
      vm.InstitutionsManager = InstitutionsManager;

      // accessibility helper for labels
      vm.getCompletedCourseNameLabel = function (completedCourse) {
        return `completed-course-name-${completedCourse.catalogId}`;
      };
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'dashboard/templates/nv-completed-course-card.html',
  };
}
